import React, { useContext, useState, useMemo } from "react";

import { CButton } from "@coreui/react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { elementToPDF } from "../../../../utils/export";
import Charts from "../../../Charts";
import LoadingStatistics from "../../../LoadingStatistics";
import StatisticFiltersCompare from "../../../StatisticFiltersCompare";
import "./styles.scss";
import { DataContext } from "../../Context/DataContext";

const HistogramaAluno = ({ activity_id: activityId }) => {
  const { studentHistogram, loading, firstLoad, user, fetchData } =
    useContext(DataContext);
  const token = useSelector(state => state.user.token);

  const [userId, setUserId] = user;

  const [data, setData] = useState(studentHistogram);

  const labels = useMemo(() => {
    const labelsArray = [];

    for (let index = 0; index < data.max; index++) {
      labelsArray.push(
        `De ${data.max * 0.1 * index} a ${(
          data.max * 0.1 * index +
          0.9
        ).toFixed(1)}`
      );
    }

    labelsArray.push(data.max);

    return labelsArray;
  }, [data]);

  const [formattedHistogram, selectedStudentBracket] = useMemo(() => {
    if (!data?.grades) return [];

    const histogramArray = new Array(11).fill(0);
    const selectedBracket = new Array(11).fill(0);

    const grade =
      data.grades?.find(item => item.user_id === userId)?.grade || 0;
    const gradeBracket = Math.floor(grade);

    data.grades.forEach(item => {
      if (Math.floor(item.grade) === gradeBracket)
        selectedBracket[Math.floor(Number(item.grade))] += 1;
      else histogramArray[Math.floor(Number(item.grade))] += 1;
    });

    return [histogramArray, selectedBracket];
  }, [data]);

  const route = "statistics/evaluation_histograms";

  const changeFilter = selected => {
    if (selected.groupId === 0) {
      return;
    }

    if (selected.regionId === 0) {
      toastr.warning("Atenção", "Preencha o regional");
      return;
    }

    if (selected.schoolId === 0) {
      toastr.warning("Atenção", "Preencha a escola");
      return;
    }

    if (selected.roomId === 0) {
      toastr.warning("Atenção", "Preencha a turma");
      return;
    }

    if (selected.userId === 0) {
      toastr.warning("Atenção", "Preencha o estudante");
      return;
    }

    setUserId(selected.userId);

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      activity_id: activityId
    };

    fetchData(params, token, route, setData);
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : data?.grades?.length > 0 && data ? (
          <div className="w-100">
            <div className="d-flex w-100 justify-content-end mt-3 mb-2">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  elementToPDF("toPrint", "Histograma dos Alunos.pdf")
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
              </CButton>
            </div>
            <div className="w-100" id="toPrint">
              <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
                <div className="row">
                  <div className="chart w-100">
                    <Charts
                      legendX="Nota"
                      legendY="Total de estudantes"
                      type="bar"
                      title="Histograma dos estudantes"
                      data={{
                        labels,
                        datasets: [
                          {
                            data: formattedHistogram,
                            label: "Histograma dos estudantes",
                            backgroundColor: "rgba(54, 162, 235, 0.2)",
                            borderColor: "rgba(54, 162, 235, 1)",
                            borderWidth: 1
                          },
                          {
                            data: selectedStudentBracket,
                            label: "Estudante selecionado",
                            backgroundColor: "rgba(255, 99, 132, 0.2)",
                            borderColor: "rgba(255, 99, 132, 1)",
                            borderWidth: 1
                          }
                        ]
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : firstLoad ? (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Selecione os filtros para pesquisar
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Nenhuma aplicação da avaliação foi encontrada
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistogramaAluno;
